import { render, staticRenderFns } from "./AccountRole.vue?vue&type=template&id=5adeb930&"
import script from "./AccountRole.vue?vue&type=script&lang=ts&"
export * from "./AccountRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports